document.addEventListener('DOMContentLoaded', function () {
  if (document.querySelector('#menu') !== undefined) {
    let menuTrigger = document.createElement('div')
    menuTrigger.classList.add('menu--trigger')
    let logo = document.querySelector('#logo')
    let menuOpen = false
    logo.insertBefore(menuTrigger, logo.querySelector('#lang'))
    var toggleMenu = function () {
      if (!menuOpen) {
        document.querySelector('#menu ul').classList.add('menu--open')
        menuOpen = true
        document.addEventListener('mousedown', clickOutsideCallback)
      } else {
        menuOpen = false
        document.querySelector('#menu ul').classList.remove('menu--open')
        document.removeEventListener('mousedown', clickOutsideCallback)
      }
    }
    var clickOutsideCallback = function (ev) {
      console.log(event.target)
      if (event.target.closest('.menu--trigger') || event.target.closest('#menu ul')) {
        return
      }
      toggleMenu()
    }
    menuTrigger.addEventListener('click', (ev) => {
      toggleMenu()
    })
  }
})



// WEBPACK FOOTER //
// ./resources/scripts/index.js